const zhCreateFile: Record<string, { message: string; description: string }> = {
  "ledgerEditor.nameYourFile": {
    message: "命名你的文件...",
    description: "Placeholder for file name input",
  },
};

export default zhCreateFile;
